import { render, staticRenderFns } from "./WaterHazardView.vue?vue&type=template&id=45b518fe&scoped=true&"
import script from "./WaterHazardView.vue?vue&type=script&lang=js&"
export * from "./WaterHazardView.vue?vue&type=script&lang=js&"
import style0 from "./WaterHazardView.vue?vue&type=style&index=0&id=45b518fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b518fe",
  null
  
)

export default component.exports